import GeneralAnchor from "./GeneralAnchor.jsx";

export default GeneralAnchor;
